import { useState, useEffect } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";

import "./Analytics.css";

function Analytics() {
  // const [totalViews, setTotalViews] = useState(0);
  // const [totalUserViews, setTotalUserViews] = useState(0);
  const [data, setData] = useState([]);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const loggedInEnterpriseId =
  activeAccount?.idTokenClaims?.enterpriseID || "";
  //const baseURL = "http://localhost:9000";
  const baseURL = "https://communityoflearning.accenture.com/communityoflearning-apis";

  const lkmPagesAnalytics = () => {
    axios
      .post(`${baseURL}/analytics`, {
        enterprise_id: loggedInEnterpriseId,
      },
    {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        })
      .then((response) => {
        getAnalytics();
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAnalytics = () => {
    axios
      .get(`${baseURL}/analytics`,
        {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
      )
      .then((response) => {
        setData(response.data);
        // setTotalViews(response.data.totalViews);
        // setTotalUserViews(response.data.totalUniqueUsers);
        console.log("res", response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const safeData = Array.isArray(data) ? data : [];

  const totalUserViews = safeData.map(
    (view) => view?.totalUniqueUsers || 0
  );
  const totalViews = safeData.reduce((acc, view) => {
    const innerData = Array.isArray(view?.Data) ? view.Data : [];

    const sumOfViews = innerData.reduce(
      (sum, userView) => sum + Number(userView?.total_views || 0),
      0
    );

    return acc + sumOfViews;
  }, 0);

  console.log("totalViews", totalViews, "totalUserViews", totalUserViews);
  useEffect(() => {
    if (process.env.NODE_ENV === "production" && loggedInEnterpriseId !== "")
      lkmPagesAnalytics();
  }, []);

  return (
    <>
      {process.env.NODE_ENV === "production" && (
        <span className="analytics-span">
          <img
            src={process.env.PUBLIC_URL + "/images/medium-eye.png"}
            className="eye-icon"
            alt="eye"
          />
          Total Views: {totalViews} &nbsp; | &nbsp; Unique Views:{" "}
          {totalUserViews}
        </span>
      )}{" "}
    </>
  );
}

export default Analytics;
